/** OpenWeather informa de onde o vento vem. A seta aponta para onde ele vai. */
export function windFlowDegrees(windFromDegrees) {
  const value = Number(windFromDegrees);
  if (!Number.isFinite(value)) return 0;
  return ((value + 180) % 360 + 360) % 360;
}
